import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsersComponent } from '@app/features/users/users/users.component';
import { AddUserComponent } from '@app/features/users/add-user/add-user.component';
import { ViewUserComponent } from '@app/features/users/view-user/view-user.component';
import { EditUserComponent } from '@app/features/users/edit-user/edit-user.component';

const routes: Routes = [
  { path: '', component: UsersComponent },
  { path: 'add', component: AddUserComponent },
  { path: ':userId/edit', component: EditUserComponent },
  { path: ':userId', component: ViewUserComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UsersRoutingModule { }
